import { getFeatureEnabled } from '@gig/magic-common';
import { Feature } from '@gig/magic-messages';
export * from '@gig/magic-account-types/dist/sign-up-constants';

var SignUpError;
(function (SignUpError) {
    // Note: MOBILE is duplicated deliberately.
    SignUpError["WRONG_VERIFICATION_CODE"] = "MOBILE_MOBILE_VERIFICATION_CODE_COMBINATION_INVALID";
    SignUpError["VERIFICATION_CODE_REQUIRED"] = "MOBILE_VERIFICATION_CODE_NULL_OR_EMPTY";
    SignUpError["UNEXPECTED_VERIFICATION_ERROR"] = "UNEXPECTED_VERIFICATION_ERROR";
    SignUpError["UNEXPECTED_REGISTER_ERROR"] = "UNEXPECTED_REGISTER_ERROR";
    SignUpError["FETCH_CONFIG_FAILED"] = "FETCH_CONFIG_FAILED";
    SignUpError["MOBILE_AND_PREFIX_INVALID"] = "MOBILE_AND_PREFIX_INVALID";
    SignUpError["SMS_TIMEOUT_HAS_NOT_EXPIRED"] = "SMS_TIMEOUT_HAS_NOT_EXPIRED";
    SignUpError["MOBILE_ALREADY_REGISTERED"] = "MOBILE_AND_PREFIX_COMBINATION_ALREADY_REGISTERED";
    SignUpError["MOBILE_ALREADY_EXISTS"] = "MOBILE_ALREADY_EXISTS";
    SignUpError["INVALID_VERIFICATION_CODE"] = "INVALID_VERIFICATION_CODE";
    SignUpError["GEO_LOCATION_NOT_AUTHORIZED"] = "Not authorized";
    SignUpError["GEO_LOCATION_INVALID_GEORESPONSE"] = "Invalid GeoResponse";
    SignUpError["GEO_LOCATION_REQUIRED_GEORESPONSE"] = "GeoResponse is required";
    SignUpError["COUNTRY_IS_EXCLUDED"] = "Country is excluded";
    SignUpError["COUNTRY_INVALID"] = "COUNTRY_INVALID";
    SignUpError["MULTIPLE_ACCOUNT_CHECK_FAILED"] = "MULTIPLE_ACCOUNT_CHECK_FAILED";
    SignUpError["USER_PROFILE_MISSING"] = "USER_PROFILE_MISSING";
    SignUpError["ID_VERIFICATION_FAILED"] = "ID_VERIFICATION_FAILED";
    SignUpError["AGE_VERIFICATION_FAILED"] = "AGE_VERIFICATION_FAILED";
    SignUpError["ADVERSE_MEDIA_VERIFICATION_FAILED"] = "ADVERSE_MEDIA_VERIFICATION_FAILED";
    SignUpError["ADDRESS_VERIFICATION_FAILED"] = "ADDRESS_VERIFICATION_FAILED";
    SignUpError["SOURCE_OF_WEALTH_VERIFICATION_FAILED"] = "SOURCE_OF_WEALTH_VERIFICATION_FAILED";
    SignUpError["KYC_VERIFICATION_FAILED"] = "KYC_VERIFICATION_FAILED";
    SignUpError["SELF_EXCLUSION_CHECK_FAILED"] = "SELF_EXCLUSION_CHECK_FAILED";
    SignUpError["PEP_VERIFICATION_FAILED"] = "PEP_VERIFICATION_FAILED";
    SignUpError["SANCTION_VERIFICATION_FAILED"] = "SANCTION_VERIFICATION_FAILED";
    SignUpError["PEP_MONITORING_FAILED"] = "PEP_MONITORING_FAILED";
    SignUpError["SANCTION_MONITORING_FAILED"] = "SANCTION_MONITORING_FAILED";
    SignUpError["JSON_PAYLOAD_INVALID"] = "JSON_PAYLOAD_INVALID";
    SignUpError["MISMATCH"] = "MISMATCH";
    SignUpError["MISMATCH_ERROR_TRANSLATION"] = "MISMATCH_ERRORT_TRANSLATION";
})(SignUpError || (SignUpError = {}));
var SignupErrorTranslationKeys;
(function (SignupErrorTranslationKeys) {
    SignupErrorTranslationKeys["MOBILE_ALREADY_REGISTERED"] = "sign-up.error.mobile-in-use";
    SignupErrorTranslationKeys["MOBILE_AND_PREFIX_INVALID"] = "sign-up.error.mobile-invalid";
    SignupErrorTranslationKeys["SMS_TIMEOUT_HAS_NOT_EXPIRED"] = "sign-up.error.sms-timeout";
    SignupErrorTranslationKeys["INVALID_VERIFICATION_CODE"] = "sign-up.notice.wrong-verification-code";
    SignupErrorTranslationKeys["GENERIC"] = "sign-up.error.generic";
    SignupErrorTranslationKeys["GENERIC_GEO_LOCATION_ERROR"] = "sign-up.error.geo-location";
    SignupErrorTranslationKeys["COUNTRY_IS_EXCLUDED"] = "sign-up.error.country-is-excluded";
    SignupErrorTranslationKeys["MULTIPLE_ACCOUNT_CHECK_FAILED"] = "wandx-sign-up-notice.multiple_account_check_failed";
    SignupErrorTranslationKeys["USER_PROFILE_MISSING"] = "wandx-sign-up-notice.user_profile_missing";
    SignupErrorTranslationKeys["ID_VERIFICATION_FAILED"] = "wandx-sign-up-notice.id_verification_failed";
    SignupErrorTranslationKeys["AGE_VERIFICATION_FAILED"] = "wandx-sign-up-notice.age_verification_failed";
    SignupErrorTranslationKeys["ADVERSE_MEDIA_VERIFICATION_FAILED"] = "wandx-sign-up-notice.adverse_media_verfification_failed";
    SignupErrorTranslationKeys["ADDRESS_VERIFICATION_FAILED"] = "wandx-sign-up-notice.address_verification_failed";
    SignupErrorTranslationKeys["SOURCE_OF_WEALTH_VERIFICATION_FAILED"] = "wandx-sign-up-notice.source_of_wealth_verification_failed";
    SignupErrorTranslationKeys["KYC_VERIFICATION_FAILED"] = "wandx-sign-up-notice.kyc_verification_failed";
    SignupErrorTranslationKeys["SELF_EXCLUSION_CHECK_FAILED"] = "wandx-sign-up-notice.self_exclusion_check_failed";
    SignupErrorTranslationKeys["PEP_VERIFICATION_FAILED"] = "wandx-sign-up-notice.pep_verification_failed";
    SignupErrorTranslationKeys["SANCTION_VERIFICATION_FAILED"] = "wandx-sign-up-notice.sanction_verification_failed";
    SignupErrorTranslationKeys["PEP_MONITORING_FAILED"] = "wandx-sign-up-notice.pep_monitoring_failed";
    SignupErrorTranslationKeys["SANCTION_MONITORING_FAILED"] = "wandx-sign-up-notice.sanction_monitoring_failed";
    SignupErrorTranslationKeys["JSON_PAYLOAD_INVALID"] = "wandx-sign-up-notice.json_payload_invalid";
    SignupErrorTranslationKeys["MISMATCH"] = "sign-up.notice.invalid.fields";
    SignupErrorTranslationKeys["MISMATCH_ERROR_TRANSLATION"] = "wandx-sign-up-notice.mismatch";
})(SignupErrorTranslationKeys || (SignupErrorTranslationKeys = {}));
/**
 * Differenciate between the 2 phone numbers available in core:
 * mobile and landline (phone)
 */
var PhoneType;
(function (PhoneType) {
    PhoneType["MOBILE"] = "mobile";
    PhoneType["PHONE"] = "phone";
})(PhoneType || (PhoneType = {}));
var IS_ACCOUNT_VERIFIED = 'is-account-verified';
function isUsernameStoreEnabled() {
    return getFeatureEnabled(Feature.PREPOPULATE_USERNAME_KC);
}
function storeUsername(username) {
    localStorage.setItem('signup-username', username);
}
function getStoredUsername() {
    return localStorage.getItem('signup-username');
}

export { IS_ACCOUNT_VERIFIED, PhoneType, SignUpError, SignupErrorTranslationKeys, getStoredUsername, isUsernameStoreEnabled, storeUsername };
